import request from "@/plugins/axios";
// process.env.NODE_ENV === "test" 单元测试
const isDev =
  process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test";
const url = !isDev ? "" : "/api";

export interface User {
  id: number;
  userName: string;
  // 是否通过企业认证（0未通过 1通过）
  isCertificated: 0 | 1;
  // 系统全局支付方式（0不需要支付 5宝付通余额 10宝付通扫码）
  payType: 0 | 5 | 10;
  userImage: string;
  chainAddress: string;
  openId: string;
  /**
   * 用户公钥
   */
  credential: string;
  /**
   * 用户加密的私钥（keystore）
   */
  privateKey?: string;
  isRegister: null | 1;
  // 是否绑定手机号
  bindStatus: null | 1;
  firmVerify: number; // 0: 未认证, 1: 已认证, 2: 认证中, 3: 认证失败
  firmName: string;
  userNo: string; // 用户编号
  description: string; // 用户简介
}

/**
 * 扫码后设置登录状态为已扫码
 * @param { string } scene
 * @returns null
 */
export const setLoginStateAsScannedEnd = (scene: string) => {
  return request({
    url: `${url}/login/updateLoginState`,
    method: "POST",
    data: {
      scene,
    },
  });
};

/**
 * h5登录
 * @param {
 *  code: string; // 微信code
 *  scene: string // 二维码唯一标识
 * } options
 * @returns null
 */
export const sendRegisterLogin = (options: { code: string; scene: string }) => {
  return request({
    url: `${url}/login/registerLogin`,
    method: "POST",
    data: options,
  });
};

/**
 * 查询登录状态
 * @param { string } scene
 * stateCode：0：未登录，1：已扫码，2：已登录，3：已退出
 * @returns {
 * stateCode: 0 | 1 | 2 | 3,
 * stateName: '未登录' | '已扫码' | '已登录' | '已退出
 * }
 */
export const getLoginState = (scene: string) => {
  return request<{
    stateCode: 0 | 1 | 2 | 3;
    stateName: "未登录" | "已扫码" | "已登录" | "已退出";
  }>({
    url: `${url}/login/queryScene`,
    method: "POST",
    data: {
      scene,
    },
  });
};
/**
 * 登录casdoor
 * @param { string } orderCode
 */
export const loginCasDoor = (options: { code: string; state: string }) => {
  return request({
    url: `${url}/login/registerLogin/new`,
    method: "POST",
    data: options,
  });
};

/**
 * 查询支付状态
 * @param { string } orderCode
 */
export const getPayState = (orderCode: string) => {
  return request({
    url: `${url}/task/queryPayState`,
    method: "POST",
    data: { orderCode },
  });
};

/**
 * 查询用户信息
 */
export const getUserInfo = () => {
  return request<User>({
    url: `${url}/login/getUserInfo`,
    method: "POST",
  });
};

/**
 * 查询字典
 */
export const getDict = (options: { dataType: string; pid: number }) => {
  return request<
    {
      dataExtra: string;
      dataType: string;
      dataValue: string;
    }[]
  >({
    url: `${url}/common/dict`,
    method: "POST",
    data: options,
  });
};

/**
 * 上传文件
 */
export const uploadFile = (file: File | Blob) => {
  return request<string>({
    url: `${url}/common/upload`,
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: {
      file,
    },
  });
};

/**
 * 发送验证码
 * smsType 1 绑定手机号 2 修改密码
 */
export const sendSmsVerifyCode = (params: {
  mobile: string;
  smsType: number;
}) => {
  return request<boolean>({
    url: `${url}/user/sms/verifyCode`,
    method: "POST",
    data: params,
  });
};
/**
 * 发送邮箱验证码
 * smsType 1 绑定手机号 2 修改密码
 */
export const sendEmailVerifyCode = (email: string) => {
  return request<boolean>({
    url: `${url}/user/sms/verifyCode`,
    method: "POST",
    data: {
      email,
      smsType: 2,
    },
  });
};

/**
 * 验证短信验证码 用户绑定手机
 */
export const bindUserMobile = (params: {
  mobile: string;
  verifyCode: string;
  smsType: number;
}) => {
  return request<boolean>({
    url: `${url}/user/bind`,
    method: "POST",
    data: params,
  });
};

/**
 * 验证修改授权密码短信并绑定用户手机
 */
export const updatePassCheck = (params: {
  mobile?: string;
  email?: string;
  verifyCode: string;
}) => {
  return request<boolean>({
    url: `${url}/user/updatePass/check`,
    method: "POST",
    data: params,
  });
};

/**
 * 获取rocket chat token
 * type 1 典枢用户 2 临时用户
 * tmpUserId 临时用户id,当type是2时需要传，传当前时间戳+4位随机数
 */
export const chatLogin = (params: { type: number; tmpUserId?: number }) => {
  return request<string>({
    url: `${url}/chat/login`,
    method: "POST",
    data: params,
  });
};

/**
 * 发起rocket会话，获取房间id
 * initiatorType  1 典枢用户 2 临时用户
 * initiator  对话的发起用户id，type为2时不填
 * recipientType  1 典枢用户 3 客服
 * recipient  对话的接收用户id，recipientType为3时不填
 */
export interface ChatConversationResponse {
  roomId: string;
  roomName?: string;
  unread?: number;
  initiatorToken?: string;
}
export const chatConversation = (params: {
  initiatorType: number;
  initiator?: number;
  recipient?: number;
  recipientType?: number;
}) => {
  return request<ChatConversationResponse>({
    url: `${url}/chat/conversation`,
    method: "POST",
    data: params,
  });
};

export const chatSendAutoMessage = () => {
  return request({
    url: `${url}/chat/server/autoMessage`,
    method: "POST",
  });
};
